const BreakPatternForms = {
  sampleUploadFile: [
    {
      Type: 'Promo',
      SegmentPosition: 'After Asset',
      Optional: 'Yes',
      Priority: '',
      Selection: 'Rotation',
      ExternalID: '9092984',
      EventName: '',
      Position: '1',
    },
    {
      Type: 'ID',
      SegmentPosition: 'After Asset',
      Optional: 'No',
      Priority: '',
      Selection: 'Ad-hoc',
      ExternalID: '6426778',
      EventName: '',
      Position: '2',
    },
    {
      Type: 'Slate',
      SegmentPosition: 'All But Last',
      Optional: 'No',
      Priority: '',
      Selection: 'Fixed',
      ExternalID: '6424752',
      EventName: '',
      Position: '3',
    },
    {
      Type: 'Promo',
      SegmentPosition: 'Before Asset',
      Optional: 'Yes',
      Priority: '',
      Selection: 'Random',
      ExternalID: '6424575',
      EventName: '',
      Position: '4',
    },
  ],
  importModalComponents: {
    import: 'import',
    confirm: 'confirm',
    loading: 'loading',
    success: 'success',
  },
};

export default BreakPatternForms;
